import { render } from "./typeahead_Form.vue?vue&type=template&id=b3bc96ca"
import script from "./typeahead_Form.vue?vue&type=script&lang=js"
export * from "./typeahead_Form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__